"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = onInitialized;
function onInitialized(event) {
  this.emit('initialized', event);
  delete window.jwplayer.key;

  // LoadTimeInit set in onScriptLoad
  this.logger.times.LoadTimeInit = performance.now() - this.logger.times.LoadTimeInit;
  this.logger.logTime('LoadTime-Init', this.logger.times.LoadTimeInit);
  if (this.config.autoplay === true) {
    this.logger.times.LoadTimeVideo = performance.now();
  }
  this._playerState.initialized = true;

  // Show the video container
  var videoContainer = this.getVideoContainer();
  videoContainer.style.visibility = 'visible';

  // Don't show first frame if a poster or ads are configured on the playable
  if (!this.config.autoplay && !(this.currentPlayable && (this.currentPlayable.poster || this.currentPlayable.ads))) {
    this.play();
    this.pause();
  }
}